export default __webpack_public_path__ + "c08afb5b5c9e3f7611f8cc1e5ffd03d7.png";